import { COMPRESS_CONFIG } from "./compress_config";

export const compressImage = (file, config = COMPRESS_CONFIG) => {
    return new Promise((resolve, reject) => {
      // Skip jika bukan gambar
      if (!file.type.startsWith("image/")) {
        reject(new Error("Bukan file gambar"));
        return;
      }
  
      // Skip jika file sudah kecil (di bawah 500KB) - tidak perlu compress
      if (file.size < 500 * 1024) {
        resolve(file);
        return;
      }
  
      const img = new Image();
      const reader = new FileReader();
  
      reader.onload = (e) => {
        img.src = e.target.result;
      };
  
      reader.onerror = () => reject(new Error("Gagal membaca file"));
  
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
  
        let { width, height } = img;
  
        // Hitung rasio baru jika melebihi max
        if (width > config.maxWidth || height > config.maxHeight) {
          const ratio = Math.min(config.maxWidth / width, config.maxHeight / height);
          width = Math.round(width * ratio);
          height = Math.round(height * ratio);
        }
  
        canvas.width = width;
        canvas.height = height;
  
        // Gambar ke canvas dengan kualitas tinggi
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(img, 0, 0, width, height);
  
        // Convert ke blob dengan kualitas yang ditentukan
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error("Gagal mengompres gambar"));
              return;
            }
  
            // Buat File object baru dari blob
            const compressedFile = new File([blob], file.name.replace(/\.[^/.]+$/, ".jpg"), {
              type: config.outputType,
              lastModified: Date.now()
            });
  
            resolve(compressedFile);
          },
          config.outputType,
          config.quality
        );
      };
  
      img.onerror = () => reject(new Error("Gagal memuat gambar"));
  
      reader.readAsDataURL(file);
    });
  };